export enum BLOG_STATUS {
  draft = 0,
  published,
  archived
}

export enum BLOG_STATUS_TRANSITION_TYPE {
  publish = 'publish',
  unpublish = 'unpublish',
  archive = 'archive',
  reopen = 'reopen'
}
